import logo from './logo.svg';
import './App.css';
// App.js
import React from 'react';
import RadarChart from './RadarChart';

function App() {
  return (
    <div style={{ height: '100vh' }}>
      <RadarChart />
    </div>
  );
}

export default App;
